import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'pbc-source-docs',
  templateUrl: './source-docs.component.html'
})
export class SourceDocsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
